import BoxKit from "@/shared/components/kit/box";
import CardKit from "@/shared/components/kit/card";
import StackKit from "@/shared/components/kit/stack";
import TypoGraphyKit from "@/shared/components/kit/typoGraphy";
import CreditCardIcon from "@mui/icons-material/CreditCard";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import NorthWestIcon from "@mui/icons-material/NorthWest";
import CustomButton from "@/shared/components/kit/button";
import { useNavigate } from "react-router";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/autoplay";
import "@/style/global.css";
import useAccountStore from "@/store/balanceStore";
import { numberSeparator } from "@/hooks/useThousandsSeparator";
/**
 * WalletBalance
 *
 * نمایش موجودی کیف پول کاربر شامل موجودی نقدی و موجودی اعتباری.
 * دارای اسلایدر اتوماتیک بین دو نوع موجودی و دکمه افزایش موجودی.
 *
 * @returns JSX.Element
 */

const WalletBalance = () => {
  const navigate = useNavigate();
  const { balance, credit } = useAccountStore();

  return (
    <CardKit
      width={"100%"}
      height={179}
      title={
        <StackKit
          direction={"row"}
          justifyContent={"space-between"}
          sx={{ minHeight: "70px" }}
        >
          <StackKit direction={"row"} gap={2}>
            <CreditCardIcon style={{ color: "#082A2E" }} />
            <TypoGraphyKit variant="header">موجودی نقدی</TypoGraphyKit>
          </StackKit>
          <StackKit
            onClick={() => navigate("/wallet-reports/cash-balance-recharge")}
            sx={{
              background: "#082A2E",

              borderRadius: "50%",

              width: "30px",
              height: "30px",
            }}
            justifyContent={"center"}
            alignItems={"center"}
          >
            <NorthWestIcon
              style={{
                color: "#fff",
                width: "16px",
                height: "16px",
                cursor: "pointer",
              }}
            />
          </StackKit>
        </StackKit>
      }
      sx={{
        background: "#FDFDFD",
        backdropFilter: "blur(242.1999969482422px)",
      }}
    >
      <StackKit
        direction={"row"}
        justifyContent={"space-between"}
        alignItems={"center"}
        sx={{ width: "100%" }}
      >
        <CustomButton
          sx={{ bgcolor: "#89C6CE !important" }}
          onClick={() => navigate("/wallet-reports/cash-balance-recharge")}
        >
          <TypoGraphyKit variant="body1">افزایش موجودی</TypoGraphyKit>
        </CustomButton>
        <StackKit
          direction={"row"}
          justifyContent={"space-between"}
          gap={2}
          alignItems={"center"}
        >
          <TypoGraphyKit variant="body1" fontSize={"20px"}>
            {numberSeparator(balance)}
          </TypoGraphyKit>
          <TypoGraphyKit variant="body1" fontSize={"12px"}>
            ریال
          </TypoGraphyKit>
        </StackKit>
      </StackKit>
    </CardKit>
  );
};

export default WalletBalance;
